import orderStatuses from "../../../../helpers/orderStatuses";

export default function() {
    return {
        orders: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        orderColumn: null,
        orderDirection: null,
        searchParams: {
            status: null,
            roles: null,
            futureTrips: true,
            pastTrips: false,
            'trip.id': null
        },
        tripInitialValue: null,
        tripInitialDisplay: '',
        places: [],
        apiUrl: process.env.VUE_APP_API_URL,
        availableStatus: [
            {
                label: 'Pago',
                value: 3
            },
            {
                label: 'Cancelado',
                value: 8
            },
            {
                label: 'Reembolsado',
                value: 4
            },
            {
                label: 'Reembolso pendente',
                value: 6
            },
            {
                label: 'Todos',
                value: null
            }
        ],
        fields: [
            {
                key: 'id',
                label: 'ID Pedido',
                sorter: false
            },
            {
                key: 'travelerName',
                label: 'Comprador',
                sorter: false
            },
            {
                key: 'placeName',
                label: 'Destino',
                sorter: false
            },
            {
                key: 'status',
                label: 'Status',
                sorter: false
            },
            {
                key: 'date',
                label: 'Data do pedido'
            },
            {
                key: 'duration',
                label: 'Data da trip'
            },
            {
                key: 'actions',
                label: 'Detalhes',
                sorter: false
            }
        ],
        orderStatuses
    }
}
